import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { Bar, Line } from "react-chartjs-2";
import {targets, useReferentialContext} from "../../Context";
import {Fade, Select, Stack} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";

export default function VariableDistribution(props: {paramObject: any, target: targets, metric: string, label: string, bucket_size: number, min: number, max: number,
    gaussianParameters?:{mean:number, std:number, label?:string, multiplier?:number, color?:string}[],
    poissonParameters?:{mean:number, label?:string, multiplier?:number, color?:string}[]}) {
    console.log(props.paramObject);
    const [rows, setRows] = useState([] as any[]);
    const api = useReferentialContext().farsightApi.getSummariesApi(props.target);
    const [chartType, setCharType] = useState('Line');

    useEffect(() => {
        setRows([]);
        const request_parameters = {
            ...props.paramObject,
            bucket_size: props.bucket_size,
            min: props.min,
            max: props.max,
            metric: props.metric,
        }
        api.variable_distribution(request_parameters).then(r => setRows(r));

    }, [props.paramObject.watermark, props.min, props.max, props.metric]);

    const options = {
        responsive: true,
        lineTension: 0.3,
    };

    const densityNormal = (value: number, mean: number, stdev: number) => {
        const SQRT2PI = Math.sqrt(2 * Math.PI);
        stdev = (stdev == null) ? 1 : stdev;
        const z = (value - (mean || 0)) / stdev;
        return Math.exp(-0.5 * z * z) / (stdev * SQRT2PI);
    };

    function poissonDistribution(lambda: number, k: number): number {
        const factorial = (n: number): number => {
            if (n === 0 || n === 1) {
                return 1;
            } else {
                return n * factorial(n - 1);
            }
        };

        const numerator = Math.exp(-lambda) * Math.pow(lambda, k);
        const denominator = factorial(k);

        return numerator / denominator;
    }

    // console.log(rows)
    const data = {
        labels: rows.map((row: any) => `${row['bucket']}`),
        datasets: [
            {
                label: props.label,
                data: rows.map((row: any) => row.proportion),
                borderColor: "rgb(139, 42, 82)",
                backgroundColor: "rgba(139, 42, 82, 1)",
                pointRadius: 5,
                pointHoverRadius: 10,
            },
        ],
    };

    if(props.gaussianParameters && chartType!=='Bar'){

        const gaussians = props.gaussianParameters.map(({mean, std, label, multiplier, color}, index) =>(
            {
                label: label ? label : "Gaussian " + index,
                data: rows.map((row: any) => densityNormal(row.bucket, mean, std) * props.bucket_size * (multiplier ? multiplier : 1)),
                borderColor: color ? color: "rgb(255, 255, 255)",
                backgroundColor: color ? color: "rgb(255, 255, 255)",
                pointRadius: 1,
                pointHoverRadius: 1,
            })
        )

        data.datasets = [...data.datasets, ...gaussians]
    }
    if(props.poissonParameters && chartType!=='Bar'){

        const poissons = props.poissonParameters.map(({mean, label, multiplier, color}, index) =>(
            {
                label: label ? label : "Gaussian " + index,
                data: rows.map((row: any, rowIndex: number) => (poissonDistribution(mean * 10, rowIndex)) * props.bucket_size * (multiplier ? multiplier : 10)),
                borderColor: color ? color: "rgb(255, 255, 255)",
                backgroundColor: color ? color: "rgb(255, 255, 255)",
                pointRadius: 1,
                pointHoverRadius: 1,
            })
        )

        data.datasets = [...data.datasets, ...poissons]
    }


    return (
        <Stack direction={'row'}
            component={"fieldset"}
            sx={{
                borderRadius: 3,
                height: "100%",
                width: "100%",
                alignItems: "center",
                justifyContent: "center",
                display: "flex",
                padding: 3
            }}
               spacing={3}
        >
            <legend>{props.label}</legend>
            <Select value={chartType} onChange={(event) => setCharType(event.target.value)}>
                <MenuItem value={'Line'}>Line</MenuItem>
                <MenuItem value={'Bar'}>Bar</MenuItem>
            </Select>
            {chartType === 'Bar' ?
                <Box sx={{height: "100%", width: "100%"}}>
                    <Bar options={options} data={data} width={"100%"} height={"100%"}/>
                </Box>
                 :
                <Box sx={{height: "100%", width: "100%" }}>
                    <Line options={options} data={data} width={"100%"} height={"100%"}/>
                </Box>}
        </Stack>
    );
}
